import { getRegions } from '@luxuryescapes/lib-regions';

import { getOfferPackageName } from '../PackageSetupStep/utils';

export interface PackageMissingCurrencies {
  missingCurrencyCodes: Array<string>;
  packageName: string;
}

// The currencies svc-offer requires a price for before it will content-approve a package.
export function getRequiredCurrencyCodes(): Array<string> {
  return Array.from(new Set(getRegions().map((region) => region.currencyCode)));
}

export function getPackagesMissingCurrencies(
  packages: Array<App.Package>,
  requiredCurrencyCodes: Array<string> = getRequiredCurrencyCodes(),
): Array<PackageMissingCurrencies> {
  return packages.flatMap((offerPackage) => {
    const pricedCurrencyCodes = new Set(
      ('prices' in offerPackage ? (offerPackage.prices ?? []) : []).map((price) => price.currency_code),
    );
    const missingCurrencyCodes = requiredCurrencyCodes.filter((code) => !pricedCurrencyCodes.has(code));

    return missingCurrencyCodes.length > 0
      ? [{ missingCurrencyCodes, packageName: getOfferPackageName(offerPackage) }]
      : [];
  });
}

export function formatPackageMissingCurrencies(
  { missingCurrencyCodes, packageName }: PackageMissingCurrencies,
  requiredCurrencyCount: number,
) {
  return missingCurrencyCodes.length === requiredCurrencyCount
    ? `- ${packageName}: no prices`
    : `- ${packageName}: ${missingCurrencyCodes.join(', ')}`;
}
